import loadBranchApi from '@zocdoc/components/src/utils/loadBranchApi';
import isZocdocBrand from '../utils/isZocdocBrand';
import { isProduction } from '../utils/environment';

const trackOnBranch = () => {
    // this only runs client-side, so passing hostname to isProduction isn't required
    if (typeof window !== 'undefined' && isProduction()) {
        loadBranchApi();
    }
};

/**
 * Condition that we want to do anything with branch.io. (track custom event, show banner etc.)
 * If your app needs to use branch banner, add the appropriate condition here.
 * @param state
 * @returns {*|boolean}
 */
export const branchTrackerMiddleware = store => next => action => {
    const state = store.getState();
    if (isZocdocBrand(state.theme.directoryId)) {
        trackOnBranch();
    }

    return next(action);
};
